import React, { useState } from 'react'

export default function TextArea(props) {

    const [text, setText] = useState("");            // syntax for creating hook.
    // setText("new text");                // ese hum text ki value ko change kr skte hai

    const handleOnChange = (e) => {
        setText(e.target.value);
    }

    const handleUppCase = () => {
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert('Converted to Uppercase successfully!', 'success');
    }

    const handleLowCase = () => {
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert('Converted to Lowercase successfully!', 'success');
    }

    const handleClear = () => {
        let newText = "";
        setText(newText);
        props.showAlert('Text cleared successfully!', 'success');
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(text);
        props.showAlert('Copied to clipboard successfully!', 'success');
    }

    const handleExtraSpaces = () => {
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));
        props.showAlert('Extra spaces are Removed successfully!', 'success');
    }

    // const handleCapCase = () => {
    //     // console.log('trigger on click');
    //     const arr = text.split(" ");
    //     for (let i = 0; i < arr.length; i++) {
    //         arr[i] = text.charAt(0).toUpperCase() + text.slice(1);
    //     }
    //     let newText = arr.join(" ");
    //     setText(newText);
    // }

    
    return (
        <>
            <div className='container' style={{ color: props.mode === 'light' ? 'black' : 'white' }}>
                <h2>{props.heading}</h2>
                <div className="input-group textareaLight textareaDark ">
                    <textarea placeholder='Enter text here....' style={{ backgroundColor: props.mode === 'light' ? 'white' : '#212529', color: props.mode === 'light' ? 'black' : 'white' }} className="  form-control" rows={6} aria-label="With textarea" id='myBox' value={text} onChange={handleOnChange}></textarea>
                </div>
                <button disabled={text.length === 0} className="btn btn-primary my-2 mx-1" onClick={handleUppCase}>Convert to UpperCase</button>
                <button disabled={text.length === 0} className="btn btn-primary my-2 mx-1" onClick={handleLowCase}>Convert to LowerCase</button>
                <button disabled={text.length === 0} className="btn btn-primary my-2 mx-1" onClick={handleClear}> Clear</button>
                <button disabled={text.length === 0} className="btn btn-primary my-2 mx-1" onClick={handleCopy}> Copy</button>
                <button disabled={text.length === 0} className="btn btn-primary my-2 mx-1" onClick={handleExtraSpaces}> Remove Extra Spaces</button>
                {/* <button className="btn btn-primary my-3 mx-1" onClick={handleCapCase}>Convert to Capitalize Case</button> */}
            </div>
            <div className="container" style={{ color: props.mode === 'light' ? 'black' : 'white' }}>
                <h3>Your Summary </h3>
                <h6>{text.split(/\s+/).filter((element) => { return element.length !== 0 }).length} Words and {text.length} Characters </h6>
                <h6>It takes {0.008 * (text.split(/\s+/).filter((element) => { return element.length !== 0 }).length)} Minutes to Read this :</h6>
                <h3> Preview </h3>
                <ul><li className='pre'> <pre>{text.length > 0 ? text : "Nothing to Preview!!"}</pre> </li></ul>
            </div>
        </>
    )
}
